import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Optional, Renderer2, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';

import { BaseDialog } from '../base.dialog';
import { Concept, Dictionary } from '../../../domain/data';
import { ErrorDialog } from '../error/error.dialog';
import { GetDictionaryUseCase } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './dictionary.dialog.html',
    styleUrls: ['./dictionary.dialog.scss'],
})
export class DictionaryDialog extends BaseDialog implements AfterViewInit, OnDestroy, OnInit {
    public dictionaries: Dictionary[] = [];
    public concepts: Concept[] = [];
    public current: Dictionary;

    @ViewChild('conceptsWrapper')
    private conceptsWrapper: ElementRef;

    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        private dialog: MatDialog,
        private getDictionaryUseCase: GetDictionaryUseCase,
        @Optional() public dialogRef: MatDialogRef<DictionaryDialog>
    ) {
        super(parentEvents, el, renderer);
    }

    ngOnInit() {
        this.getDictionaryUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.dictionaries = transaction.data as Dictionary[];

                    if (this.dictionaries && this.dictionaries.length > 0) {
                        this.current = this.dictionaries[0];
                        this.onCategoryClick();
                    }
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    onClose() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }

    onCategoryClick() {
        this.dictionaries.map((it) => {
            if (it.id === this.current.id) {
                this.concepts = it.concepts as Concept[];
            }
        });

        if (this.conceptsWrapper) {
            (this.conceptsWrapper.nativeElement as HTMLElement).scrollTop = 0;
        }
    }
}
